import React from "react";
import { ButtonBase, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface HomeLinkProps {
  sx?: object;
}

function HomeLink({ sx }: HomeLinkProps) {
  const navigate = useNavigate();
  return (
    <ButtonBase
      aria-label="Go to home page"
      onClick={() => navigate("/")}
      sx={{
        borderRadius: 1,
        zIndex: 10,
        cursor: "pointer",
        ...sx,
      }}
      disableRipple
    >
      <Typography
        variant="h3"
        sx={{
          fontFamily: '"Times New Roman", serif',
          fontWeight: 100,
        }}
      >
        Theo
      </Typography>
    </ButtonBase>
  );
}

export { HomeLink };
